/**
 * Navigation starten, ohne dass Martin die Karte antippen muss.
 *
 * 18.10.2026: Sagt er „starte die Navigation“, setzt das Modell
 * `navigation_starten` am Werkzeug; das Ergebnis trägt dann `autoOeffnen`.
 * Die App öffnet den Maps-Link einmal selbst — NUR beim Live-Aufruf, nie beim
 * Nachladen des Verlaufs (sonst öffnete jeder Reload alle alten Routen).
 * Safari/PWA verwirft ein Öffnen ohne Nutzergeste oft: das ist best-effort,
 * die Karte bleibt mit dem Knopf „Navigation starten“ als Rückfall.
 */
import { openExternalUrl } from "./app-browser.js";
import { unwrapResult } from "./karten/hilfe.js";

/** Nur ein echter Google-Maps-Routenlink wird je selbst geöffnet. */
const MAPS_ROUTE = /^https:\/\/www\.google\.com\/maps\/dir\//;

/** Schon geöffnet: Aufruf-Kennung oder Link — ein Aufruf öffnet nie zweimal. */
const geoeffnet = new Set<string>();

/** Der Link, der geöffnet werden darf — oder null (kein Start-Wunsch, Fehler, falscher Link). */
export function autoOeffnenUrl(result: unknown): string | null {
  const r = unwrapResult(result) as { ok?: unknown; autoOeffnen?: unknown; mapsUrl?: unknown };
  if (r.ok === false || r.autoOeffnen !== true) return null;
  return typeof r.mapsUrl === "string" && MAPS_ROUTE.test(r.mapsUrl) ? r.mapsUrl : null;
}

/**
 * Öffnet die Route, falls Start-Wunsch, live und noch nicht geöffnet.
 * Gibt zurück, ob ein Öffnen versucht wurde (Test und Aufrufer).
 */
export function oeffneRouteWennGewuenscht(
  card: { result: unknown; callId?: string; isError?: boolean },
  live: boolean,
  oeffne: (url: string) => void = openExternalUrl,
): boolean {
  if (!live || card.isError) return false;
  const url = autoOeffnenUrl(card.result);
  if (!url) return false;
  const schluessel = card.callId || url;
  if (geoeffnet.has(schluessel) || geoeffnet.has(url)) return false;
  geoeffnet.add(schluessel);
  geoeffnet.add(url);
  try {
    oeffne(url);
  } catch {
    /* Safari/WKWebView ohne Geste — die Karte mit dem Knopf bleibt */
  }
  return true;
}

/** Nur für Tests. */
export function vergissGeoeffnete(): void {
  geoeffnet.clear();
}
